export default function ListSeparator() {
  return (
    <div
      data-variante="Solid"
      className="self-stretch inline-flex justify-start items-start">
      <div className="flex-1 h-px bg-neutrals-N300" />
    </div>
  );
}
